import { env } from "../env";
import { ENGLISH_APP_ORIGIN, KOREAN_APP_ORIGIN } from "../i18n/locale";

const DEFAULT_NEXT_PATH = "/";

function extractSupabaseProjectRef(rawUrl?: string | null) {
  if (!rawUrl) {
    return null;
  }

  try {
    const { hostname } = new URL(rawUrl);
    const [projectRef] = hostname.split(".");
    return projectRef?.trim() || null;
  } catch {
    return null;
  }
}

export function toRelativeAppPath(input?: string | null) {
  if (!input) {
    return DEFAULT_NEXT_PATH;
  }

  try {
    const url = new URL(input, env.appUrl);
    const appOrigin = new URL(env.appUrl).origin;

    if (
      url.origin !== appOrigin
      && url.origin !== KOREAN_APP_ORIGIN
      && url.origin !== ENGLISH_APP_ORIGIN
    ) {
      return DEFAULT_NEXT_PATH;
    }

    const nextPath = `${url.pathname}${url.search}${url.hash}`;
    return nextPath.startsWith("/") ? nextPath : DEFAULT_NEXT_PATH;
  } catch {
    return input.startsWith("/") ? input : DEFAULT_NEXT_PATH;
  }
}

export function buildKakaoAuthorizeUrl(next?: string | null) {
  const params = buildKakaoLoginParams(next);
  return `/api/auth/kakao/authorize?${params.toString()}`;
}

export function buildKakaoSdkInitUrl(next?: string | null) {
  const params = buildKakaoLoginParams(next);
  return `/api/auth/kakao/sdk-init?${params.toString()}`;
}

function buildKakaoLoginParams(next?: string | null) {
  const params = new URLSearchParams({
    next: toRelativeAppPath(next),
  });
  const supabaseProjectRef = extractSupabaseProjectRef(env.supabaseUrl);

  if (supabaseProjectRef) {
    params.set("sb_ref", supabaseProjectRef);
  }

  return params;
}
